module.exports = __webpack_public_path__ + "media/images/flags/64/Basque-Country-2cd78dad0a5fd1c87e24c73e04405709.png";